import { render } from "./select-mjstore-orderusedrecord.vue?vue&type=template&id=6574b6be"
import script from "./select-mjstore-orderusedrecord.vue?vue&type=script&lang=ts"
export * from "./select-mjstore-orderusedrecord.vue?vue&type=script&lang=ts"
script.render = render

export default script